<template>
  <div>
    <h1 class="mb-0">New password</h1>
    <p>
      You are only one step a way from your new password, recover your password
      now.
    </p>
    <form autocomplete="off" @submit.prevent="resetPassword">
      <div class="input-group mb-3">
        <input
          type="password"
          class="form-control"
          placeholder="Password"
          v-model="data.password"
        />
      </div>
      <div class="input-group mb-3">
        <input
          type="password"
          class="form-control"
          placeholder="Confirm Password"
          v-model="data.password_confirm"
        />
      </div>
      <div class="row">
        <div class="col-12 text-right">
          <button type="submit" class="btn btn-primary">Change password</button>
        </div>
      </div>
    </form>
    <p class="mt-3 mb-1">
      <router-link to="/login" class="small float-right">Sign in</router-link>
    </p>
  </div>
</template>
<script>
import * as authService from '../../../services/auth.service'
import * as messageService from '../../../services/message.service'

export default {
  name: 'Register',
  data() {
    return {
      data: {
        code: null,
        password: null,
        password_confirm: null
      },

      has_error: false
    }
  },
  methods: {
    resetPassword: async function () {
      try {
        this.data.token = this.$route.params.code
        await authService.resetPassword(this.data)

        this.$router.push({ name: 'auth.sign-in' })
      } catch (error) {
        switch (error.response.status) {
          case 401:
            this.errors = error.response.data.errors
            messageService.fnSweetAlertErrorToast(
              'Login',
              error.response.data.message
            )
            break
          case 422:
            this.errors = error.response.data.errors
            messageService.fnSweetAlertErrorToast(
              'Login',
              error.response.data.message
            )
            break
          case 500:
            messageService.fnSweetAlertErrorToast(
              'Login',
              error.response.data.message
            )
            break
          default:
            messageService.fnSweetAlertErrorToast(
              'Login',
              'Somethig wrong, Please try again!'
            )
            break
        }
      }
    }
  }
}
</script>